import React from 'react';

interface PulseClinicalAiMarkProps {
  size?: number;
  className?: string;
  roleTheme?: 'ASSISTANT' | 'SUPERVISOR' | 'OWNER' | 'NEUTRAL';
}

/**
 * PulseClinicalAiMark — Canonical Bloom mark for Clinical AI Assist surfaces.
 * Renders the approved static transparent Bloom brand mark.
 */
export const PulseClinicalAiMark: React.FC<PulseClinicalAiMarkProps> = ({
  size = 20,
  className = '',
}) => {
  return (
    <img
      src="/brand/canonical/bloom-mark-micro.svg"
      alt="Bloom AI Assist"
      width={size}
      height={size}
      style={{ width: size, height: size }}
      className={`shrink-0 object-contain select-none ${className}`}
    />
  );
};
